import { api } from "@/lib/api";
import type { Role } from "@/features/users/api";
import { listRoles } from "@/features/users/api";

export type { Role };
export { listRoles };

export interface Permission {
  code: string;
  description: string;
  group: string; // resource prefix, e.g. "ticket"
}

export interface RoleBody {
  name: string;
  description?: string | null;
  permissions: string[];
}

export function listPermissions(): Promise<Permission[]> {
  return api.get<Permission[]>("/permissions");
}

export function createRole(body: RoleBody): Promise<Role> {
  return api.post<Role>("/roles", body);
}

export function updateRole(
  id: string,
  body: Partial<RoleBody>,
): Promise<Role> {
  return api.patch<Role>(`/roles/${id}`, body);
}

export function deleteRole(id: string): Promise<{ message: string }> {
  return api.delete<{ message: string }>(`/roles/${id}`);
}
